/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ActionsColumn/view.blocks to change it.
import Actions from './Actions/index'
import React from 'react'
import ToggleLocationConnection from './ToggleLocationConnection/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ActionsColumn({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="ActionsColumn.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<ToggleLocationConnection
  viewPath={`${viewPath}/ToggleLocationConnection`}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
{children}
</React.Fragment>)
}